/*eslint react-hooks/exhaustive-deps: "off"*/
import { Spin, Tooltip as AntdTooltip } from "antd";
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from "react";
import useAxiosGet from "../../utils/hooks/useAxios";
import { getSplitList } from "../../utils";
import WidgetGeolocated from "./widgets/WidgetGeolocated";
import MapPropsContext from "./MapPropsContext";
import { DEBUG, MAP_VENDOR } from "../../Constants";

import WidgetMapLayerTypes from "./widgets/WidgetMapLayerTypes";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MapBaseLeaflet from "./base_maps/MapBaseLeaflet";
import WidgetToggleClustering from "./widgets/WidgetToggleClustering";
import WidgetZoom from "./widgets/WidgetZoom";
import WidgetMapType from "./widgets/WidgetMapType";
import WidgetCurrentLocation from "./widgets/WidgetCurrentLocation";
import WidgetMeasure from "./widgets/WidgetMeasure";
import WidgetPrint from "./widgets/WidgetPrint";
import { ACTIONS as ACTIONS_VIEWSTATE } from "./reducerViewState";
import useRequestApiForMapViewport from "./useRequestApiForMapViewport";
import MapCenterMark from "./widgets/MapCenterMark";

const MapBase = ({
  children,
  isIgnoreCenterChangeEvent,
  isHideControls,
  isHideControlsOnLeftSide,
  isHideControlsOnRightSide,
  isHideWidgetMapType,
  isHideWidgetToggleClustering,
  isHideWidgetMapLayerTypes,
  isHideControlOnClustering,
  isHideMeasureControl,
  isHideGeolocated,
  mapBaseStyle,
  mapContainerStyle,
}) => {
  const containerRef = useRef();

  const onGeolocatedControlClick = useCallback(
    ({ latitude, longitude }) => {
      const currentRoute = window.location.pathname.split("/");
      const currentPage = currentRoute[currentRoute.length - 1];

      if (currentPage == "radiomap.do") {
        dispatchViewState({
          type: ACTIONS_VIEWSTATE.UPDATE_VIEWPORT,
          payload: {
            latitude,
            longitude,
            zoom: 9, // RRR; 2020.08.05: 지역별 주파수 찾기 현재위치 아이콘 눌렀을 시 zoom 설정.
          },
        });
      } else {
        dispatchViewState({
          type: ACTIONS_VIEWSTATE.UPDATE_VIEWPORT,
          payload: {
            latitude,
            longitude,
            zoom: 16, // 2020.03.02: 현재위치 아이콘 눌렀을 시 반경 검색 확대되도록(디폴트화면처럼)
          },
        });
      }

      if (typeof window["radiomapAction"] == "function") {
        window["radiomapAction"]();
      }
    },
    [viewState, dispatchViewState]
  );

  const {
    viewState,
    dispatchViewState,
    setGeojsonPolygonsResponseList,
    setPointsResponseList,
    setDataResponseList,
  } = useContext(MapPropsContext);

  // FIXME: App.js의 containerOffsetTop을 전달받기
  const [containerOffsetTop, setContainerOffsetTop] = useState(0);
  const [geojsonUrlDict, setGeojsonUrlDict] = useState({});
  const { isLoading, responseList, setRequestUrlList } = useAxiosGet();

  const [debugMeta, setDebugMeta] = useState({});

  useEffect(() => {
    const { y, top } = document
      .getElementById("react-root")
      .getBoundingClientRect();
    setContainerOffsetTop(y || top);
  }, []);

  useRequestApiForMapViewport((response) => {
    if (response) {
      const { data: _geojsonUrlDict } = response;
      const { data, points, geojson_polygons } = _geojsonUrlDict;
      setRequestUrlList(data.concat(points, geojson_polygons));
      setGeojsonUrlDict({
        data,
        points,
        geojson_polygons,
      });
    }
  });

  useEffect(() => {
    const { latitude, longitude, zoom } = viewState;
    setDebugMeta({ ...debugMeta, latitude, longitude, zoom });
  }, [viewState]);

  useEffect(() => {
    const { geojson_polygons, points, data } = geojsonUrlDict;

    const dataLength = (data || []).length;
    const pointsLength = (points || []).length;
    const geojsonPolygonsLength = (geojson_polygons || []).length;

    const totalLength = dataLength + pointsLength + geojsonPolygonsLength;

    if (totalLength === responseList.length) {
      // 스프링 단에서는 없는 geojson 파일 응답에 대해서는 404 응답 대신에 empty body 응답을 합니다.
      // json 파일 응답이 있는 경우에는 object 응답을 하기에 string인 경우는 제외시킵니다.
      const existedResponseList = responseList.filter(
        (response) => typeof response !== "string"
      );

      // 위 getGeojsonUrlList에서 넣은 순서대로 polygon, point, data 응답을 slice합니다.
      const [
        _dataResponseList,
        _pointsResponseList,
        _geojsonPolygonsResponseList,
      ] = getSplitList(existedResponseList, [
        dataLength,
        pointsLength,
        geojsonPolygonsLength,
      ]);

      // Data Layer를 먼저 계산토록 하기 위해서,
      if (setDataResponseList) {
        setDataResponseList(_dataResponseList);
      }

      // 임의의 시간 (0.5초)를 딜레이로 줬습니다.
      setTimeout(() => {
        setPointsResponseList(_pointsResponseList);
        setGeojsonPolygonsResponseList(_geojsonPolygonsResponseList);
      }, 500);
    }
  }, [responseList]);

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        height: `calc(100vh - ${containerOffsetTop}px)`,
        ...mapBaseStyle,
        ...mapContainerStyle,
      }}
      className={"map-base-container-r"}
    >
      {/* <div style={CENTER_LAYER_STYLE}>+</div> */}

      {/* <MapCenterMark /> */}

      <MapBaseLeaflet
        containerOffsetTop={containerOffsetTop}
        mapContainerStyle={mapContainerStyle}
      >
        {!(isHideControls || isHideControlsOnRightSide) && (
          <div
            style={{ position: "absolute", top: 160, right: 3, zIndex: 400 }}
            className={"map-base-util-r"}
          >
            {/* 6. 거리 측정 */}
            {!isHideMeasureControl && <WidgetMeasure />}
            {/* 7. 인쇄 */}
            <WidgetPrint />
          </div>
        )}
      </MapBaseLeaflet>

      <div
        style={{ position: "absolute", top: 45, right: 50, zIndex: 0 }}
        className={"map-base-view-r"}
      >
        {!(
          isHideControls ||
          isHideWidgetToggleClustering ||
          isHideControlsOnRightSide ||
          isHideControlOnClustering
        ) && (
          // 1. 클러스터링 아이콘
          <WidgetToggleClustering
            tooltipPlacement={"bottom"}
            style={{ display: "inline-block", marginRight: 4 }}
          />
        )}

        {!(
          isHideControls ||
          isHideWidgetMapLayerTypes ||
          isHideControlsOnRightSide
        ) && (
          <WidgetMapLayerTypes
            tooltipPlacement={"bottom"}
            style={{ display: "inline-block" }}
          />
        )}
      </div>

      {!(isHideControls || isHideControlsOnLeftSide) && (
        <WidgetCurrentLocation
          style={{ position: "absolute", top: 8, left: 5, zIndex: 1 }}
        />
      )}

      <div
        style={{ position: "absolute", top: 1.2, right: 0, zIndex: 1 }}
        className={"map-base-header-r"}
      >
        {!(
          isHideControls ||
          isHideWidgetMapType ||
          isHideControlsOnRightSide
        ) && (
          <WidgetMapType
            style={{ display: "inline-block", marginRight: 4 }}
            isDisabled={MAP_VENDOR === "google" ? true : false}
          />
        )}
        <div
          className="toolbar-show-chart"
          style={{ display: "inline-block", marginLeft: 0, marginRight: 4 }}
        />
        <div
          className="toolbar-show-list"
          style={{ display: "inline-block", marginLeft: 0, marginRight: 4 }}
        />
        <div
          className="toolbar-show-help"
          style={{ display: "inline-block", marginLeft: 0, marginRight: 2 }}
        />
      </div>

      {!(isHideControls || isHideControlsOnRightSide || isHideGeolocated) && (
        // 3. 현재 위치 찾기
        <WidgetGeolocated
          onClick={onGeolocatedControlClick}
          style={{ position: "absolute", top: 45, right: 3, zIndex: 1 }}
          className={"map-base-current-r"}
        />
      )}

      {!(isHideControls || isHideControlsOnRightSide) && (
        // 4-5. 확대 축소
        <WidgetZoom
          style={{ position: "absolute", top: 85, right: 3, zIndex: 1 }}
          className={"map-base-scale-r"}
        />
      )}

      {!(isHideControls || isHideControlsOnRightSide) && DEBUG && debugMeta && (
        <div style={DEBUG_STYLE}>
          <AntdTooltip
            placement={"bottom"}
            title={
              <div>
                <ul style={{ padding: 0, margin: 0, fontSize: "0.8em" }}>
                  {debugMeta.district && (
                    <li>
                      법정동코드: {debugMeta.district.code},
                      {debugMeta.district.name}
                    </li>
                  )}
                  <li>
                    CENTER : {debugMeta.latitude},{debugMeta.longitude}
                  </li>
                  <li>ZOOM: {debugMeta.zoom}</li>
                </ul>
                {JSON.stringify(viewState)}
              </div>
            }
          >
            <FontAwesomeIcon icon={faQuestion} /> 디버깅 정보
          </AntdTooltip>
        </div>
      )}

      {children}

      {isLoading && <Spin size="large" style={SPIN_STYLE} />}
    </div>
  );
};

const SPIN_STYLE = {
  position: "absolute",
  left: "50%",
  top: "50%",
  marginLeft: "-30px",
  marginTop: "-50px",
};

// const CENTER_LAYER_STYLE = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   width: '24px',
//   height: '24px',
//   lineHeight: '24px',
//   marginLeft: '-12px',
//   marginTop: '-12px',
//   textAlign: 'center',
//   verticalAlign: 'middle',
//   zIndex: 1,
//   userSelect: 'none',
//   pointerEvents: 'none',
// };

const DEBUG_STYLE = {
  position: "absolute",
  padding: "4px",
  background: "rgba(0, 0, 0, 0.8)",
  color: "#fff",
  maxWidth: "320px",
  fontSize: "14px",
  margin: "0 auto",
  zIndex: 9,
  left: "50%",
  width: 100,
  marginLeft: -50,
  top: 3,
  overflow: "hidden",
};

export default MapBase;
